import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
  // Public routes
  {
    path: '',
    loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent)
  },
  {
    path: 'inschrijven',
    loadComponent: () => import('./pages/checkout/checkout.component').then(m => m.CheckoutComponent)
  },
  {
    path: 'r/:token',
    loadComponent: () => import('./pages/reservation-portal/reservation-portal.component').then(m => m.ReservationPortalComponent)
  },

  // Admin routes
  {
    path: 'admin/login',
    loadComponent: () => import('./pages/admin/login/admin-login.component').then(m => m.AdminLoginComponent)
  },
  {
    path: 'admin',
    loadComponent: () => import('./pages/admin/layout/admin-layout.component').then(m => m.AdminLayoutComponent),
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/admin/dashboard/admin-dashboard.component').then(m => m.AdminDashboardComponent)
      },
      {
        path: 'concerts',
        loadComponent: () => import('./pages/admin/concerts/concert-list/concert-list.component').then(m => m.ConcertListComponent)
      },
      {
        path: 'concerts/:id',
        loadComponent: () => import('./pages/admin/concerts/concert-detail/concert-detail.component').then(m => m.ConcertDetailComponent)
      },
      {
        path: 'bank-imports',
        loadComponent: () => import('./pages/admin/bank-imports/bank-imports.component').then(m => m.BankImportsComponent)
      },
      {
        path: 'email-logs',
        loadComponent: () => import('./pages/admin/email-logs/email-logs.component').then(m => m.EmailLogsComponent)
      },
      {
        path: 'reservations',
        loadComponent: () => import('./pages/admin/reservations/reservations-overview.component').then(m => m.ReservationsOverviewComponent)
      },
      {
        path: 'payment-history',
        loadComponent: () => import('./pages/admin/payment-history/payment-history.component').then(m => m.PaymentHistoryComponent)
      }
    ]
  },

  // Fallback
  {
    path: '**',
    redirectTo: ''
  }
];
